<head>

<script src="https://unpkg.com/vue"></script>
<script src="https://unpkg.com/vue-cal"></script>
<link href="https://unpkg.com/vue-cal/dist/vuecal.css" rel="stylesheet">
</head>
<template>
  <br />
  <div class="row" style="margin-bottom: 10px">
    <span><h2>Listar Atendentes</h2></span>
  </div>
  <div class="row">
    <div class="col-2">
      <button type="button" class="btn btn-primary" @click="criarNova" style="margin-right: 10px">Criar novo</button>
    </div>
  </div>
  <a-table :dataSource="lista" :columns="columns">
    <template #action="{ record }">
      <a title="Excluir" @click="excluirSecretaria(record)"><i class="fas fa-trash icon-trash"></i></a> &nbsp;&nbsp;
      <a title="Editar" @click="editarSecretaria(record)"><i class="fas fa-edit icon-edit"></i></a>
    </template>
  </a-table>
</template>

<script>
import { openNotification, typesNotification } from '@/utils/notifications';
import { deleteSecretariaById, getListaSecretarias } from '@/components/service/secretariasService';

export default {
  name: 'PageListarSecretaria',
  data() {
    return {
      lista: [],
      columns: [
        {
          title: 'CPF',
          dataIndex: 'cpf',
          key: 'cpf',
          slots: { customRender: 'cpf' },
        },
        {
          title: 'Nome',
          dataIndex: 'nome',
          key: 'nome',
          slots: { customRender: 'nome' },
        },
        {
          title: 'Ações',
          dataIndex: 'action',
          key: 'action',
          slots: { customRender: 'action' },
        },
      ],
    };
  },
  methods: {
    excluirSecretaria(record) {
      deleteSecretariaById(record.id)
        .then(() => {
          this.carregarTabela();
        })
        .catch(() => {
          openNotification(typesNotification.error, 'Falha ao excluir secretaria!');
        });
    },
    editarSecretaria(record) {
      this.$router.push({ path: '/form-secretarias', query: { id: record.id } });
    },
    criarNova() {
      this.$router.push('form-secretarias');
    },
    carregarTabela() {
      getListaSecretarias()
        .then((r) => {
          this.lista = r.data;
        })
        .catch(() => {
          openNotification(typesNotification.error, 'Falha ao recuperar a lista de atendentes cadastrados!');
        });
    },
  },
  created() {
    this.carregarTabela();
  },
};
</script>

<style>
.input-group-text {
  height: 38px;
}

.input-group-prepend {
  cursor: pointer;
  margin-left: 8px !important;
}

.input-group-text:hover {
  background-color: #e0e0e0 !important;
}

.h2 {
  font-size: x-large;
}
</style>
